import {Component, ElementRef, OnInit, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {HeaderService} from "../../../../../services/header/header.service";
import {ToastrService} from "ngx-toastr";
import {Router, ActivatedRoute} from "@angular/router";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr";
import * as Feather from 'feather-icons';
import {TresorerieService} from "../../../../../services/tresorerie/tresorerie.service";
import {BanqueService} from "../../../../../services/Banque/banque.service";
import {Banque} from "../../../../../models/banque.model";
import {forkJoin, Observable} from "rxjs";
import {Tresorerie} from '../../../../../models/Tresorerie/Tresorerie';
import {RemiseBanque} from '../../../../../models/Tresorerie/RemiseBanque';
import {CategorieTresorerie} from '../../../../../models/Tresorerie/CategorieTresorerie';
import {PaiementService} from "../../../../../services/paiement/paiement.service";
import {Paiement} from "../../../../../models/paiement/Paiement";
import {LignePaiement} from "../../../../../models/paiement/LignePaiement";
import {DocumentService} from "../../../../../services/document/document.service";

@Component({
  selector: 'app-detail-banque',
  templateUrl: './detail-banque.component.html',
  styleUrls: ['./detail-banque.component.scss']
})
export class DetailBanqueComponent implements OnInit, AfterViewInit {
    @ViewChild('dateDuInput') dateDuInput!: ElementRef;
    @ViewChild('dateJusquaInput') dateJusquaInput!: ElementRef;

    compteBancaireId: number | null = null;
    isLoading = false;
    tresorerieData: Tresorerie[] = [];
    remisesBanqueData: RemiseBanque[] = [];
    remisesBanqueMap: { [key: number]: RemiseBanque } = {};
    paiementsData: Paiement[] = [];
    documentReferencesCache: { [documentId: number]: string } = {}; // Cache pour les références de documents
    
    items: any[] = [];
    filteredData: any[] = [];
    searchTerm = '';
    showFilter = false;
    selectedItem: any = null;
    basicSelectedOption = 10;
    currentPage = 1;
    totalPages = 1;
    pages: number[] = [];
    filterSummary = '';

    banques: Banque[] = [];
    categories: CategorieTresorerie[] = [];
    stationId: number | null = null;

    filters: any = {
        banque_id: '',
        type_operation: '',
        type_transaction: '',
        categorie_id: '',
        type_paiement: '',
        chiffre_aff: '',
        operator: '=',
        date_du: '',
        date_jusqua: ''
    };

    // Propriétés pour le filtrage de date (utilisées pour le filtrage côté client)
    dateFilterStart: string = '';
    dateFilterEnd: string = '';

    constructor(
        private toastr: ToastrService,
        private tresorerieService: TresorerieService,
        private banqueService: BanqueService,
        private paiementService: PaiementService,
        private documentService: DocumentService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private headerService: HeaderService,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.headerService.setConfig({
            title: 'Compte bancaire',
            buttons: []
        });

        this.loadUserData();

        setTimeout(() => {
            this.loadBanques();
            this.loadCategories();
        }, 100);

        this.route.queryParams.subscribe(params => {
            this.compteBancaireId = params['compte_bancaire_id'] ? parseInt(params['compte_bancaire_id'], 10) : null;
            if (this.compteBancaireId) {
                this.loadData();
            } else {
                this.toastr.error('Compte bancaire non spécifié.', 'Erreur');
                this.retour();
            }
        });

        // Ne pas initialiser les dates de filtre - toutes les données seront affichées par défaut
        this.dateFilterStart = '';
        this.dateFilterEnd = '';
    }

    retour() {
        this.router.navigate(['/comptabilite/banque']);
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : null;
                console.log('📋 [DetailBanqueComponent] Station ID chargé:', this.stationId);
            }
        } catch (error) {
            console.error('❌ [DetailBanqueComponent] Erreur lors de la récupération des données utilisateur:', error);
        }
    }

    private loadBanques(): void {
        console.log('🏦 [DetailBanqueComponent] Chargement des banques...');
        console.log('🏦 [DetailBanqueComponent] Station ID:', this.stationId);

        const banquesObservable = this.stationId 
            ? this.banqueService.getBanques(this.stationId)
            : this.banqueService.getAllBanques();
        
        banquesObservable.subscribe({
            next: (response: any) => {
                console.log('🏦 [DetailBanqueComponent] Réponse API banques complète:', response);

                let banquesList: Banque[] = [];
                if (response && response.banques && Array.isArray(response.banques)) {
                    banquesList = response.banques;
                } else if (response && response.data && Array.isArray(response.data)) {
                    banquesList = response.data;
                } else if (Array.isArray(response)) {
                    banquesList = response;
                }

                this.banques = banquesList;
                console.log('✅ [DetailBanqueComponent] Banques chargées:', this.banques.length);
                console.log('✅ [DetailBanqueComponent] Première banque:', this.banques[0]);
                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error('❌ [DetailBanqueComponent] Erreur lors du chargement des banques:', error);
                console.error('   - Status:', error.status);
                console.error('   - Message:', error.message);
                this.toastr.error('Erreur lors du chargement des banques.', 'Erreur');
            }
        });
    }

    private loadCategories(): void {
        const stationId = this.stationId ?? 0;
        if (!stationId) {
            this.categories = [];
            return;
        }
        console.log('📋 [DetailBanqueComponent] Chargement des catégories...');
        this.tresorerieService.getCategories(stationId).subscribe({
            next: (response: any) => {
                console.log('📋 [DetailBanqueComponent] Réponse API catégories complète:', response);

                let categoriesList: CategorieTresorerie[] = [];
                if (Array.isArray(response)) {
                    categoriesList = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        categoriesList = response.data;
                    } else if (response.data.categories && Array.isArray(response.data.categories)) {
                        categoriesList = response.data.categories;
                    } else if (response.data.data && Array.isArray(response.data.data)) {
                        categoriesList = response.data.data;
                    }
                } else if (response && response.categories && Array.isArray(response.categories)) {
                    categoriesList = response.categories;
                }

                this.categories = categoriesList;
                console.log('✅ [DetailBanqueComponent] Catégories chargées:', this.categories.length);
                console.log('✅ [DetailBanqueComponent] Première catégorie:', this.categories[0]);
                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error('❌ [DetailBanqueComponent] Erreur lors du chargement des catégories:', error);
                console.error('   - Status:', error.status);
                console.error('   - Message:', error.message);
                this.toastr.error('Erreur lors du chargement des catégories.', 'Erreur');
            }
        });
    }

    loadData() {
        if (!this.compteBancaireId) {
            console.warn('⚠️ [DetailBanqueComponent] compteBancaireId non défini');
            return;
        }

        console.log('🔄 [DetailBanqueComponent] Chargement des données pour banque_id:', this.compteBancaireId);
        this.isLoading = true;
        
        forkJoin({
            tresorerie: this.tresorerieService.getTresorerieByCompteBancaire(this.compteBancaireId),
            remises: this.tresorerieService.getRemisesBanqueByCompteBancaire(this.compteBancaireId),
            paiements: this.loadPaiementsByCompteBancaire()
        }).subscribe({
            next: (results: {tresorerie: Tresorerie[], remises: RemiseBanque[], paiements: Paiement[]}) => {
                console.log('✅ [DetailBanqueComponent] Données chargées avec succès:');
                console.log('   - Opérations de trésorerie:', results.tresorerie.length);
                console.log('   - Remises en banque:', results.remises.length);
                console.log('   - Paiements:', results.paiements.length);
                
                this.tresorerieData = results.tresorerie;
                this.remisesBanqueData = results.remises;
                this.paiementsData = results.paiements;

                this.remisesBanqueMap = {};
                this.remisesBanqueData.forEach(remise => {
                    if (remise.id) {
                        this.remisesBanqueMap[remise.id] = remise;
                    }
                });

                console.log('📊 [DetailBanqueComponent] Map des remises créée:', Object.keys(this.remisesBanqueMap).length, 'remises');

                // Charger les références des documents avant de transformer les données
                this.loadDocumentReferences().then(() => {
                    this.transformData();
                    this.updateFilteredData();
                    this.isLoading = false;
                });
            },
            error: (error) => {
                console.error('❌ [DetailBanqueComponent] Erreur lors du chargement des données:', error);
                console.error('   - Status:', error.status);
                console.error('   - Message:', error.message);
                console.error('   - Error:', error.error);
                this.toastr.error('Erreur lors du chargement des données.', 'Erreur');
                this.isLoading = false;
            }
        });
    }

    /**
     * Charge tous les paiements qui ont des lignes avec le banque_id OU des lignes de type espece
     */
    private loadPaiementsByCompteBancaire(): Observable<Paiement[]> {
        return new Observable(observer => {
            console.log('🔄 [loadPaiementsByCompteBancaire] Début du chargement pour banque_id:', this.compteBancaireId);
            this.paiementService.getPaiements().subscribe({
                next: (response: any) => {
                    console.log('📦 [loadPaiementsByCompteBancaire] Réponse brute:', response);
                    let paiements: Paiement[] = [];
                    
                    // Normaliser la réponse
                    if (Array.isArray(response)) {
                        paiements = response;
                    } else if (response && response.data) {
                        if (Array.isArray(response.data)) {
                            paiements = response.data;
                        } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
                            paiements = response.data.paiements;
                        }
                    }

                    console.log('📦 [loadPaiementsByCompteBancaire] Paiements normalisés:', paiements.length);

                    // Filtrer les paiements qui ont des lignes avec le banque_id OU des lignes de type espece
                    const paiementsFiltres = paiements.filter(paiement => {
                        if (!paiement.lignes_paiement || paiement.lignes_paiement.length === 0) {
                            return false;
                        }
                        
                        // Vérifier si au moins une ligne de paiement a le banque_id OU est de type espece
                        const hasMatchingLigne = paiement.lignes_paiement.some(ligne => {
                            // Inclure les lignes avec banque_id correspondant
                            const matchesBanqueId = ligne.banque_id === this.compteBancaireId;
                            // Inclure aussi les paiements en espèces (qui n'ont généralement pas de banque_id)
                            const matchesEspece = ligne.type_paiement === 'espece';
                            
                            const matches = matchesBanqueId || matchesEspece;
                            
                            if (matches) {
                                if (matchesBanqueId) {
                                    console.log(`✅ [loadPaiementsByCompteBancaire] Paiement #${paiement.id} correspond - Ligne type: ${ligne.type_paiement}, banque_id: ${ligne.banque_id}`);
                                } else if (matchesEspece) {
                                    console.log(`✅ [loadPaiementsByCompteBancaire] Paiement #${paiement.id} correspond - Ligne type: ${ligne.type_paiement} (espèce)`);
                                }
                            }
                            return matches;
                        });
                        
                        return hasMatchingLigne;
                    });

                    console.log('💰 [loadPaiementsByCompteBancaire] Paiements filtrés:', paiementsFiltres.length, 'sur', paiements.length);
                    if (paiementsFiltres.length > 0) {
                        console.log('💰 [loadPaiementsByCompteBancaire] Détails des paiements filtrés:');
                        paiementsFiltres.forEach(p => {
                            console.log(`   - Paiement #${p.id}: ${p.lignes_paiement?.length || 0} lignes`);
                            p.lignes_paiement?.forEach((ligne, idx) => {
                                if (ligne.banque_id === this.compteBancaireId || ligne.type_paiement === 'espece') {
                                    console.log(`     Ligne ${idx}: type=${ligne.type_paiement}, montant=${ligne.montant}, banque_id=${ligne.banque_id || 'N/A'}`);
                                }
                            });
                        });
                    } else {
                        console.warn('⚠️ [loadPaiementsByCompteBancaire] Aucun paiement trouvé pour banque_id:', this.compteBancaireId, 'ou type espece');
                        // Afficher quelques exemples pour déboguer
                        if (paiements.length > 0) {
                            console.log('📋 [loadPaiementsByCompteBancaire] Exemples de banque_id trouvés:');
                            paiements.slice(0, 3).forEach(p => {
                                p.lignes_paiement?.forEach(ligne => {
                                    console.log(`   - Paiement #${p.id}, Ligne type: ${ligne.type_paiement}, banque_id: ${ligne.banque_id || 'N/A'}`);
                                });
                            });
                        }
                    }
                    
                    observer.next(paiementsFiltres);
                    observer.complete();
                },
                error: (error) => {
                    console.error('❌ [loadPaiementsByCompteBancaire] Erreur:', error);
                    console.error('   - Status:', error.status);
                    console.error('   - Message:', error.message);
                    observer.next([]);
                    observer.complete();
                }
            });
        });
    }

    /**
     * Charge les références des documents pour les paiements
     */
    private loadDocumentReferences(): Promise<void> {
        return new Promise((resolve) => {
            const documentIdsToLoad = new Set<number>();
            
            // Collecter tous les document_id uniques des paiements
            this.paiementsData.forEach(paiement => {
                if (paiement.document_id) {
                    // Vérifier si la référence n'est pas déjà dans les opérations de trésorerie
                    const tresorerieAssociee = this.tresorerieData.find(t => t.paiement_id === paiement.id);
                    if (!tresorerieAssociee || !tresorerieAssociee.document_reference) {
                        if (!this.documentReferencesCache[paiement.document_id]) {
                            documentIdsToLoad.add(paiement.document_id);
                        }
                    } else {
                        // Mettre en cache la référence trouvée
                        this.documentReferencesCache[paiement.document_id] = tresorerieAssociee.document_reference;
                    }
                }
            });

            if (documentIdsToLoad.size === 0) {
                resolve();
                return;
            }

            console.log('📄 [loadDocumentReferences] Chargement des références pour', documentIdsToLoad.size, 'documents');

            // Charger les références des documents en parallèle
            const loadPromises = Array.from(documentIdsToLoad).map(documentId => {
                return new Promise<void>((resolveDoc) => {
                    this.documentService.getDocumentById(documentId).subscribe({
                        next: (response: any) => {
                            let document: any;
                            if (response && response.data && response.data.document) {
                                document = response.data.document;
                            } else if (response && response.data) {
                                document = response.data;
                            } else if (response) {
                                document = response;
                            }
                            
                            const refExterne = document?.ref_externe || null;
                            if (refExterne) {
                                this.documentReferencesCache[documentId] = refExterne;
                            }
                            resolveDoc();
                        },
                        error: (error) => {
                            console.error(`❌ [loadDocumentReferences] Erreur pour document ${documentId}:`, error);
                            resolveDoc();
                        }
                    });
                });
            });

            Promise.all(loadPromises).then(() => {
                console.log('✅ [loadDocumentReferences] Références chargées:', Object.keys(this.documentReferencesCache).length);
                resolve();
            });
        });
    }

    transformData() {
        console.log('🔄 [DetailBanqueComponent] Transformation des données...');
        console.log('   - Nombre d\'opérations de trésorerie:', this.tresorerieData.length);
        console.log('   - Nombre de paiements:', this.paiementsData.length);
        
        // Transformer les opérations de trésorerie
        const tresorerieItems = this.tresorerieData.map(tresorerie => {
            const remise = tresorerie.remise_banque_id ? this.remisesBanqueMap[tresorerie.remise_banque_id] : null;
            
            return {
                id: tresorerie.id,
                date: this.formatDate(tresorerie.date_operation),
                date_operation_raw: tresorerie.date_operation || null,
                type: this.getTypeOperationLabel(tresorerie.type_operation),
                numero: remise?.numero_remise || '--',
                document: tresorerie.document_reference || '--',
                debit: tresorerie.type_paiement === 'debit' ? this.formatMontant(tresorerie.montant) : '  0.00 TND  ',
                credit: tresorerie.type_paiement === 'credit' ? this.formatMontant(tresorerie.montant) : '  0.00 TND  ',
                tresorerie: tresorerie,
                remise: remise,
                paiement: null,
                lignePaiement: null
            };
        });

        // Transformer les paiements en items
        const paiementItems: any[] = [];
        console.log('🔄 [transformData] Transformation des paiements, nombre de paiements:', this.paiementsData.length);
        
        this.paiementsData.forEach((paiement, paiementIdx) => {
            if (!paiement.lignes_paiement || paiement.lignes_paiement.length === 0) {
                console.log(`⚠️ [transformData] Paiement #${paiement.id} n'a pas de lignes_paiement`);
                return;
            }

            console.log(`🔄 [transformData] Traitement du paiement #${paiement.id} avec ${paiement.lignes_paiement.length} lignes`);

            // Pour chaque ligne de paiement qui correspond à la banque OU est de type espece
            paiement.lignes_paiement.forEach((ligne: LignePaiement, ligneIdx: number) => {
                console.log(`   Ligne ${ligneIdx}: type_paiement=${ligne.type_paiement}, banque_id=${ligne.banque_id || 'N/A'}, montant=${ligne.montant}`);
                
                // Inclure les lignes avec banque_id correspondant OU les paiements en espèces
                const matchesBanqueId = ligne.banque_id === this.compteBancaireId;
                const matchesEspece = ligne.type_paiement === 'espece';
                
                if (matchesBanqueId || matchesEspece) {
                    if (matchesBanqueId) {
                        console.log(`   ✅ Ligne ${ligneIdx} correspond au banque_id ${this.compteBancaireId}`);
                    } else if (matchesEspece) {
                        console.log(`   ✅ Ligne ${ligneIdx} correspond (type espece)`);
                    }
                    
                    const typePaiementLabel = this.getTypePaiementLabel(ligne.type_paiement);
                    const datePaiement = ligne.date_reglement || paiement.date_paiement || new Date().toISOString();
                    
                    // Récupérer la référence du document
                    let documentReference = '--';
                    // Priorité 1: Référence depuis les opérations de trésorerie associées
                    const tresorerieAssociee = this.tresorerieData.find(t => t.paiement_id === paiement.id);
                    if (tresorerieAssociee && tresorerieAssociee.document_reference) {
                        documentReference = tresorerieAssociee.document_reference;
                        console.log(`   📄 Référence trouvée dans trésorerie: ${documentReference}`);
                    } 
                    // Priorité 2: Référence depuis le cache des documents
                    else if (paiement.document_id && this.documentReferencesCache[paiement.document_id]) {
                        documentReference = this.documentReferencesCache[paiement.document_id];
                        console.log(`   📄 Référence trouvée dans le cache: ${documentReference}`);
                    }
                    // Priorité 3: Référence du paiement (fallback)
                    else if (paiement.reference) {
                        documentReference = paiement.reference;
                        console.log(`   📄 Référence du paiement (fallback): ${documentReference}`);
                    } else {
                        console.log(`   ⚠️ Aucune référence trouvée pour paiement #${paiement.id}, document_id: ${paiement.document_id}`);
                    }
                    
                    const item = {
                        id: `paiement_${paiement.id}_ligne_${ligne.id}`,
                        date: this.formatDate(datePaiement),
                        date_operation_raw: datePaiement,
                        type: `Paiement ${typePaiementLabel}`,
                        numero: this.getNumeroPaiement(ligne),
                        document: documentReference,
                        // IMPORTANT: Les paiements sont toujours en DÉBIT (dépense)
                        debit: this.formatMontant(ligne.montant),
                        credit: '  0.00 TND  ',
                        tresorerie: null,
                        remise: null,
                        paiement: paiement,
                        lignePaiement: ligne
                    };
                    
                    console.log(`   ✅ Item créé: type=${item.type}, numero=${item.numero}, document=${item.document}, debit=${item.debit}`);
                    paiementItems.push(item);
                } else {
                    console.log(`   ❌ Ligne ${ligneIdx} ne correspond pas (banque_id: ${ligne.banque_id || 'N/A'} !== ${this.compteBancaireId} et type: ${ligne.type_paiement} !== espece)`);
                }
            });
        });

        console.log('💰 [DetailBanqueComponent] Items de paiement créés:', paiementItems.length);
        if (paiementItems.length > 0) {
            console.log('💰 [DetailBanqueComponent] Types de paiements trouvés:');
            paiementItems.forEach(item => {
                console.log(`   - ${item.type} (${item.numero}): ${item.debit}`);
            });
        }

        // Combiner toutes les listes
        this.items = [...tresorerieItems, ...paiementItems];

        // Trier par date décroissante
        this.items.sort((a, b) => {
            const dateA = new Date(a.date_operation_raw).getTime();
            const dateB = new Date(b.date_operation_raw).getTime();
            return dateB - dateA;
        });

        console.log('✅ [DetailBanqueComponent] Données transformées:', this.items.length, 'items');
    }

    /**
     * Retourne le label du type de paiement
     */
    private getTypePaiementLabel(type: string): string {
        const labels: { [key: string]: string } = {
            'espece': 'Espèce',
            'cheque': 'Chèque',
            'virement': 'Virement bancaire',
            'traite': 'Traite'
        };
        return labels[type] || type;
    }

    /**
     * Retourne le numéro selon le type de paiement
     */
    private getNumeroPaiement(ligne: LignePaiement): string {
        if (ligne.type_paiement === 'cheque' && ligne.numero_cheque) {
            return ligne.numero_cheque;
        }
        if (ligne.type_paiement === 'traite' && ligne.numero_traite) {
            return ligne.numero_traite;
        }
        if (ligne.type_paiement === 'virement' && ligne.informations_virement) {
            return ligne.informations_virement;
        }
        return '--';
    }

    getTypeOperationLabel(type: string): string {
        const labels: { [key: string]: string } = {
            'depense': 'Dépense',
            'recette': 'Recette',
            'remise_banque': 'Remise en banque',
            'operation_manuelle': 'Opération manuelle',
            'avance_espece': 'Avance en espèce'
        };
        return labels[type] || type;
    }

    formatMontant(montant: string | number): string {
        const num = typeof montant === 'string' ? parseFloat(montant) : montant;
        return isNaN(num) ? '0,000 TND' : num.toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ' TND';
    }

    ngAfterViewInit() {
        setTimeout(() => {
            Feather.replace();
            this.cdr.detectChanges();
            setTimeout(() => Feather.replace(), 100);
        }, 0);
    }

    /**
     * Applique le filtre de date - filtre côté client selon date_operation
     */
    private applyDateFilter(startDate: string, endDate: string): void {
        console.log(`🔄 [applyDateFilter] Application du filtre de date: ${startDate} - ${endDate}`);
        
        // Mettre à jour les dates de filtre
        this.dateFilterStart = startDate;
        this.dateFilterEnd = endDate;
        
        // Appliquer le filtrage sur les données déjà chargées
        this.updateFilteredData();
    }

    /**
     * Écoute les changements de date depuis le composant app-filtre-date
     */
    onDateFilterChange(event: {startDate: string, endDate: string}): void {
        console.log(`🔄 [onDateFilterChange] Changement de date depuis app-filtre-date: ${event.startDate} - ${event.endDate}`);
        this.applyDateFilter(event.startDate, event.endDate);
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
        if (this.showFilter) {
            //setTimeout(() => Feather.replace(), 0);
        }
    }

    onSearch() {
        this.updateFilteredData();
    }


    /**
     * Parse une date au format "DD / MM / YYYY" ou autres formats
     */
    private parseDate(dateStr: string | Date): Date | null {
        if (!dateStr) return null;
        
        if (dateStr instanceof Date) {
            return isNaN(dateStr.getTime()) ? null : dateStr;
        }
        
        const dateString = String(dateStr).trim();
        if (!dateString) return null;
        
        // Format "DD / MM / YYYY" avec espaces
        const match1 = dateString.match(/(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})/);
        if (match1) {
            const day = parseInt(match1[1], 10);
            const month = parseInt(match1[2], 10) - 1;
            const year = parseInt(match1[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        // Format ISO "YYYY-MM-DD"
        const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const year = parseInt(isoMatch[1], 10);
            const month = parseInt(isoMatch[2], 10) - 1;
            const day = parseInt(isoMatch[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        const parsed = new Date(dateString);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }
        
        return null;
    }

    formatDate(dateString: string) {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR');
    }

    updateFilterSummary() {
        const activeFilters: string[] = [];
        if (this.filters.type_operation) {
            const typeLabels: {[key: string]: string} = {
                'depense': 'Dépense',
                'recette': 'Recette',
                'remise_banque': 'Remise en banque',
                'operation_manuelle': 'Opération manuelle',
                'avance_espece': 'Avance en espèce'
            };
            activeFilters.push(`Type: ${typeLabels[this.filters.type_operation] || this.filters.type_operation}`);
        }
        if (this.filters.chiffre_aff) activeFilters.push(`Montant: ${this.filters.operator} ${this.filters.chiffre_aff}`);
        // Ne pas afficher le filtre de date dans le résumé - il est géré par app-filtre-date
        this.filterSummary = activeFilters.join(', ');
    }

    resetFilters() {
        this.filters = {
            banque_id: '',
            type_operation: '',
            type_transaction: '',
            categorie_id: '',
            type_paiement: '',
            chiffre_aff: '',
            operator: '=',
            date_du: '',
            date_jusqua: ''
        };
        this.searchTerm = '';
        // Réinitialiser aussi les filtres de date - afficher toutes les données
        this.dateFilterStart = '';
        this.dateFilterEnd = '';
        this.updateFilteredData();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    applyFilters() {
        console.log('🔍 [DetailBanqueComponent] Application des filtres:', this.filters);
        this.updateFilteredData();
        this.getActiveFilters();
        this.toggleFilter();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    getActiveFilters(): Array<{key: string, label: string, value: any}> {
        const activeFilters: Array<{key: string, label: string, value: any}> = [];

        if (this.filters.type_operation && this.filters.type_operation !== '') {
            const typeLabels: {[key: string]: string} = {
                'depense': 'Dépense',
                'recette': 'Recette',
                'remise_banque': 'Remise en banque',
                'operation_manuelle': 'Opération manuelle',
                'avance_espece': 'Avance en espèce'
            };
            activeFilters.push({
                key: 'type_operation',
                label: 'Type',
                value: typeLabels[this.filters.type_operation] || this.filters.type_operation
            });
        }

        if (this.filters.chiffre_aff && this.filters.chiffre_aff !== '') {
            const operatorLabel = this.filters.operator === '=' ? '=' : this.filters.operator === '>' ? '>' : '<';
            activeFilters.push({
                key: 'chiffre_aff',
                label: 'Montant',
                value: `${operatorLabel} ${this.filters.chiffre_aff} TND`
            });
        }

        // Ne pas afficher le filtre de date depuis app-filtre-date dans les boutons de filtres actifs
        // Le filtre de date est géré par le composant app-filtre-date
        
        // Afficher uniquement les dates du panneau de filtres (date_du et date_jusqua)
        if (this.filters.date_du || this.filters.date_jusqua) {
            let dateValue = '';
            if (this.filters.date_du && this.filters.date_jusqua) {
                dateValue = `${this.formatDate(this.filters.date_du)} - ${this.formatDate(this.filters.date_jusqua)}`;
            } else if (this.filters.date_du) {
                dateValue = `À partir du ${this.formatDate(this.filters.date_du)}`;
            } else if (this.filters.date_jusqua) {
                dateValue = `Jusqu'au ${this.formatDate(this.filters.date_jusqua)}`;
            }
            if (dateValue) {
                activeFilters.push({
                    key: 'date',
                    label: 'Date',
                    value: dateValue
                });
            }
        }
        
        return activeFilters;
    }

    removeFilter(filterKey: string, event?: Event): void {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        
        if (filterKey === 'date') {
            // Réinitialiser les filtres de date du panneau
            this.filters.date_du = '';
            this.filters.date_jusqua = '';
            // Ne pas réinitialiser dateFilterStart et dateFilterEnd car ils sont gérés par app-filtre-date
        } else if (filterKey === 'chiffre_aff') {
            this.filters.chiffre_aff = '';
            this.filters.operator = '=';
        } else if (this.filters.hasOwnProperty(filterKey)) {
            this.filters[filterKey] = '';
        }
        
        this.updateFilteredData();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    trackByFilterKey(index: number, filter: {key: string, label: string, value: any}): string {
        return filter.key;
    }

    updateFilteredData() {
        if (!this.items || this.items.length === 0) {
            console.warn('⚠️ [DetailBanqueComponent] Items est vide, pas de filtrage possible');
            this.filteredData = [];
            this.updatePagination();
            return;
        }

        console.log('🔍 [DetailBanqueComponent] Filtrage côté client - Filtres actifs:', this.filters);
        console.log('🔍 [DetailBanqueComponent] Nombre d\'items:', this.items.length);

        let filtered = [...this.items];

        if (this.searchTerm) {
            const searchLower = this.searchTerm.toLowerCase();
            filtered = filtered.filter(item =>
                item.type?.toLowerCase().includes(searchLower) ||
                item.numero?.toLowerCase().includes(searchLower) ||
                item.document?.toLowerCase().includes(searchLower) ||
                (item.paiement?.reference && item.paiement.reference.toLowerCase().includes(searchLower))
            );
        }

        if (this.filters.banque_id && this.filters.banque_id !== '') {
            const banqueId = Number(this.filters.banque_id);
            filtered = filtered.filter(item => {
                const itemBanqueId = item.tresorerie?.banque_id || item.tresorerie?.compte_bancaire_id;
                return itemBanqueId === banqueId;
            });
        }

        if (this.filters.type_operation && this.filters.type_operation !== '') {
            filtered = filtered.filter(item => {
                const itemType = item.tresorerie?.type_operation || item.type;
                return itemType === this.filters.type_operation;
            });
        }

        if (this.filters.type_transaction && this.filters.type_transaction !== '') {
            filtered = filtered.filter(item => {
                const itemType = item.tresorerie?.type_operation || '';
                if (this.filters.type_transaction === 'paiement') {
                    return itemType === 'recette';
                } else if (this.filters.type_transaction === 'remise_banque') {
                    return itemType === 'remise_banque';
                } else if (this.filters.type_transaction === 'operation_diverse') {
                    return itemType === 'operation_manuelle';
                } else if (this.filters.type_transaction === 'depense') {
                    return itemType === 'depense';
                } else if (this.filters.type_transaction === 'annulation') {
                    return item.tresorerie?.statut === 'annule';
                }
                return false;
            });
        }

        if (this.filters.categorie_id && this.filters.categorie_id !== '') {
            const categorieId = Number(this.filters.categorie_id);
            filtered = filtered.filter(item => {
                const itemCategorieId = item.tresorerie?.categorie_id;
                return itemCategorieId === categorieId;
            });
        }

        if (this.filters.type_paiement && this.filters.type_paiement !== '') {
            filtered = filtered.filter(item => {
                // Pour les opérations de trésorerie
                if (item.tresorerie) {
                    const itemMethodePaiement = item.tresorerie?.methode_paiement || '';
                    return itemMethodePaiement === this.filters.type_paiement;
                }
                // Pour les paiements
                if (item.lignePaiement) {
                    return item.lignePaiement.type_paiement === this.filters.type_paiement;
                }
                return false;
            });
        }

        if (this.filters.chiffre_aff && this.filters.chiffre_aff !== '') {
            filtered = filtered.filter(item => {
                let montantStr = '0';
                // Pour les opérations de trésorerie
                if (item.tresorerie) {
                    montantStr = item.tresorerie?.montant || '0';
                }
                // Pour les paiements
                else if (item.lignePaiement) {
                    montantStr = item.lignePaiement?.montant || '0';
                }
                
                const montant = parseFloat(montantStr) || 0;
                const filterValue = parseFloat(this.filters.chiffre_aff);
                
                if (isNaN(filterValue)) return true;
                
                if (this.filters.operator === '=') {
                    return Math.abs(montant - filterValue) < 0.01;
                }
                if (this.filters.operator === '>') {
                    return montant > filterValue;
                }
                if (this.filters.operator === '<') {
                    return montant < filterValue;
                }
                return true;
            });
        }

        // Filtrage selon date_operation avec dateFilterStart et dateFilterEnd (depuis app-filtre-date)
        if (this.dateFilterStart || this.dateFilterEnd) {
            filtered = filtered.filter(item => {
                // Utiliser date_operation_raw qui contient la date_operation brute
                const itemDateStr = item.date_operation_raw || item.tresorerie?.date_operation;
                if (!itemDateStr) return false;
                
                // Parser la date_operation de l'item
                const itemDate = this.parseDate(itemDateStr);
                if (!itemDate || isNaN(itemDate.getTime())) {
                    return false;
                }
                
                let matches = true;
                
                // Vérifier la date de début (début du mois ou début de l'année)
                if (this.dateFilterStart) {
                    const dateStart = this.parseDate(this.dateFilterStart);
                    if (dateStart) {
                        dateStart.setHours(0, 0, 0, 0);
                        const itemDateStart = new Date(itemDate);
                        itemDateStart.setHours(0, 0, 0, 0);
                        // L'item doit être >= dateStart (date_operation >= dateFilterStart)
                        if (itemDateStart < dateStart) {
                            matches = false;
                        }
                    }
                }
                
                // Vérifier la date de fin (fin du mois ou fin de l'année)
                if (this.dateFilterEnd && matches) {
                    const dateEnd = this.parseDate(this.dateFilterEnd);
                    if (dateEnd) {
                        dateEnd.setHours(23, 59, 59, 999);
                        const itemDateEnd = new Date(itemDate);
                        itemDateEnd.setHours(23, 59, 59, 999);
                        // L'item doit être <= dateEnd (date_operation <= dateFilterEnd)
                        if (itemDateEnd > dateEnd) {
                            matches = false;
                        }
                    }
                }
                
                return matches;
            });
        }
        
        // Filtrage selon les dates du panneau de filtres (date_du et date_jusqua)
        if (this.filters.date_du || this.filters.date_jusqua) {
            filtered = filtered.filter(item => {
                const itemDateStr = item.date_operation_raw || item.tresorerie?.date_operation;
                if (!itemDateStr) return false;
                
                const itemDate = this.parseDate(itemDateStr);
                if (!itemDate || isNaN(itemDate.getTime())) {
                    return false;
                }
                
                let matches = true;
                
                if (this.filters.date_du) {
                    const dateDu = this.parseDate(this.filters.date_du);
                    if (dateDu) {
                        dateDu.setHours(0, 0, 0, 0);
                        const itemDateStart = new Date(itemDate);
                        itemDateStart.setHours(0, 0, 0, 0);
                        if (itemDateStart < dateDu) matches = false;
                    }
                }
                
                if (this.filters.date_jusqua) {
                    const dateJusqua = this.parseDate(this.filters.date_jusqua);
                    if (dateJusqua) {
                        dateJusqua.setHours(23, 59, 59, 999);
                        const itemDateEnd = new Date(itemDate);
                        itemDateEnd.setHours(23, 59, 59, 999);
                        if (itemDateEnd > dateJusqua) matches = false;
                    }
                }
                
                return matches;
            });
        }

        this.filteredData = filtered;
        console.log('✅ [DetailBanqueComponent] Filtrage terminé:', {
            itemsAvant: this.items.length,
            itemsApres: this.filteredData.length,
            filtresActifs: {
                type_operation: this.filters.type_operation,
                chiffre_aff: this.filters.chiffre_aff,
                operator: this.filters.operator,
                date_du: this.filters.date_du,
                date_jusqua: this.filters.date_jusqua,
                dateFilterStart: this.dateFilterStart,
                dateFilterEnd: this.dateFilterEnd
            }
        });
        this.updateFilterSummary();
        this.updatePagination();
    }

    paginatedData: any[] = [];

    updatePagination() {
        this.totalPages = Math.ceil(this.filteredData.length / this.basicSelectedOption) || 1;
        this.currentPage = Math.min(this.currentPage, this.totalPages);
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        const start = (this.currentPage - 1) * this.basicSelectedOption;
        this.paginatedData = this.filteredData.slice(start, start + this.basicSelectedOption);
    }

    changePage(page: number) {
        this.currentPage = page;
        this.updatePagination();
    }


    openArchiveModal(content: TemplateRef<any>, item: any) {
        this.selectedItem = item;
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
        };
        this.modalService.open(content, options);
    }

    getRemiseDetails(): any {
        if (!this.selectedItem || !this.selectedItem.remise) {
            return null;
        }
        return {
            numero_remise: this.selectedItem.remise.numero_remise || '--',
            date_banque: this.selectedItem.remise.date_banque ? this.formatDate(this.selectedItem.remise.date_banque) : '--',
            note: this.selectedItem.remise.note || '--'
        };
    }

    hasRemise(): boolean {
        return this.selectedItem && this.selectedItem.remise ? true : false;
    }



}
